// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Forge Casino — Table Game Page
// Routes to the correct table game based on gameId
// ================================================================
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Blackjack from '../games/tables/Blackjack';
import Roulette from '../games/tables/Roulette';
import VideoPoker from '../games/tables/VideoPoker';
import Craps from '../games/tables/Craps';

const GAMES = {
  'blackjack': { component: Blackjack, title: 'Blackjack' },
  'roulette': { component: Roulette, title: 'Roulette' },
  'video-poker': { component: VideoPoker, title: 'Video Poker' },
  'craps': { component: Craps, title: 'Craps' },
};

export default function TableGamePage() {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const game = GAMES[gameId];

  if (!game) {
    return (
      <div style={styles.notFound}>
        <h2 style={styles.notFoundTitle}>GAME NOT FOUND</h2>
        <p style={styles.notFoundText}>The table game "{gameId}" doesn't exist.</p>
        <button style={styles.backBtn} onClick={() => navigate('/tables')}>
          BACK TO TABLES
        </button>
      </div>
    );
  }

  const GameComponent = game.component;

  return (
    <div style={styles.container}>
      <div style={styles.nav}>
        <button style={styles.navBtn} onClick={() => navigate('/tables')}>
          {'←'} TABLES
        </button>
        <button style={styles.navBtn} onClick={() => navigate('/lobby')}>
          LOBBY
        </button>
      </div>
      <GameComponent />
    </div>
  );
}

const styles = {
  container: {
    padding: '12px',
    maxWidth: 600,
    margin: '0 auto',
    minHeight: '100vh',
    background: '#0a0a0a',
  },
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  navBtn: {
    padding: '6px 14px',
    borderRadius: 6,
    border: '1px solid #333',
    background: '#111',
    color: '#888',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 1,
    cursor: 'pointer',
  },
  notFound: {
    textAlign: 'center',
    padding: '60px 20px',
    minHeight: '100vh',
    background: '#0a0a0a',
  },
  notFoundTitle: {
    fontSize: 24,
    color: '#DC2626',
    fontWeight: 900,
    letterSpacing: 3,
    marginBottom: 12,
  },
  notFoundText: {
    fontSize: 14,
    color: '#888',
    marginBottom: 24,
  },
  backBtn: {
    padding: '12px 24px',
    borderRadius: 8,
    border: '2px solid #DC2626',
    background: '#DC262622',
    color: '#DC2626',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 1,
    cursor: 'pointer',
  },
};
